const dashboards = [
  "https://public.tableau.com/views/RegionalSampleWorkbook/Flights",
  "https://public.tableau.com/views/RegionalSampleWorkbook/Obesity",
  "https://public.tableau.com/views/RegionalSampleWorkbook/College",
  "https://public.tableau.com/views/RegionalSampleWorkbook/Stocks",
  "https://public.tableau.com/views/RegionalSampleWorkbook/Storms"
];

export default dashboards;
